/*eslint-disable */
var $ = window.jQuery = require('jquery');

import { bus } from '@/main';
import createDataPopup from '../create-algo-data-details/';
import {
mapGetters,
} from 'vuex';
import toast from '@/services/toast';
import twoFactorDataPopup from '@/components/private/dataset/two-factor-for-data-popup/';
import updateDataPopup from '../update-algo-data-details/';

export default {
  name: 'algo-data-list',
  components: {
    'create-data' : createDataPopup,
    'update-data' : updateDataPopup,
    'two-factor-data' : twoFactorDataPopup
  },
  props: [],
  data () {
    return {
      algoDataList:null,
      algoDataListResults:[],
      createAlgoDataPopup:false,
      updateAlgoDataPopup:false,
      updateAlgoDataId:'',
      userDetails:null,
      is_superuser:false,
      is_guestuser:false,
      allDataListState:true,
      myDataListState:true,
      myDataList:null,
      myDataListResults:[],
      userAuthorizedPopupState:false,
      teamMemberList:[],
      teamMemberValue:'',
      noramalListData:true,
      selectedTeamMemberData:[],
      noramalListLoader:false,
      twoFactorVerifedPopup:false,
      twoFactorDataId:''
    }
  },
  computed: {
    ...mapGetters([
      'getAllPubAlgoDataListGetters',
      'selfUserInfoGetters',
      'getMyAlgoDataListGetters'
    ]),
    getAlgoDataListFun(){
      this.algoDataList = this.$store.getters.getAllPubAlgoDataListGetters.data;
      return
    },
    setIntialsOfDataState(){
      if(this.algoDataList){
        this.algoDataListResults = this.algoDataList.results
      }
    },
    getMyDataListFun(){
      this.myDataList = this.$store.getters.getMyAlgoDataListGetters;
      return
    },
    setIntialsOfMyDataState(){
      if(this.myDataList){
        this.myDataListResults = this.myDataList.data
      }
    },
    getUserDetailsAgainFun() {
      this.userDetails = this.$store.getters.selfUserInfoGetters.data
      return
    },
    SetIntialSuperUserStatus(){
      if (this.userDetails) {
        this.is_superuser = this.userDetails.is_superuser
        this.is_guestuser = this.userDetails.guest
      }
      return
    }
  },
  mounted () {
    this.getAlgoDataListFun
    this.setIntialsOfDataState
    this.getMyDataListFun
    this.setIntialsOfMyDataState
    bus.$on('createAlgoDataPopupBus', (data) => {
      this.createAlgoDataPopup = data;
    });
    bus.$on('updateAlgoDataPopupBus', (data) => {
      this.updateAlgoDataPopup = data;
    });
    this.getUserDetailsAgainFun
    this.SetIntialSuperUserStatus
    if(this.userDetails &&  this.userDetails.user_type == 'team_head'){
      this.getTeamMemberList()
    }
    bus.$on('twoFactorVerifedPopupBus', (data) => {
      this.twoFactorVerifedPopup = data;
    });
  },
  methods: {
    getTeamMemberList(){
      this.$store.dispatch('getUserListOfTeamHeadFun').then((res) => {
        this.teamMemberList = res.data.data.results
      })
    },
    teamMemberInfoMethod(){
      if(this.teamMemberValue){
        this.noramalListLoader = true
        this.$store.dispatch('getAlgoModelInfoOfTeamMemberFun', {id:this.teamMemberValue}).then((res) => {
          this.noramalListData = false
          this.selectedTeamMemberData = res.data.data.results 
          this.noramalListLoader = false
        }).catch((err) => {this.noramalListLoader = false})
      }else{
        this.noramalListData = true
      }
    },
    updateAlogDataDetailsMethod(algoId){
      $('body').addClass('body_right_scroll_remove')
      this.updateAlgoDataPopup = true
      this.updateAlgoDataId = algoId
    },
    createAlgoDataMethod(){
      $('body').addClass('body_right_scroll_remove')
      this.createAlgoDataPopup = true
    },
    myAlgoDataListMethod(){
      if(this.allDataListState){
        this.allDataListState = false
      }else{
        this.allDataListState = true
      }
    },
    selectedAlgoDataDetailsByIdMethod(dataId){
      this.$store.dispatch('getAllPubAlgoDataListByIdAction',{id:dataId}).then((res)=>{
        this.downloadFileMethod(res.data.data.data_file,res.data.data.data_file_name)
      }).catch((err)=>{

      })
    },
    downloadFileMethod(file,fileName){
      var link = document.createElement('a');
      link.href = file
      link.download =  fileName;
      document.body.appendChild(link);
      link.click();
    },
    userAuthriozedNotDownLoadDataMethod(){
      $('body').addClass('body_right_scroll_remove')
      this.userAuthorizedPopupState = true
    },
    userAuthorizedPopupMethod(){
      $('body').removeClass('body_right_scroll_remove')
      this.userAuthorizedPopupState = false
    },
    twoFactorVerifedPopupOpenMethod(ID){
      this.$store.dispatch('sendTwoFactorOtp', {id:ID}).then((res) => {
        toast.success(res.data.user_msg);
        this.twoFactorVerifedPopup = true
        this.twoFactorDataId = ID
        $('body').addClass('body_right_scroll_remove')
      })
    },
  },
  watch:{
    getAlgoDataListFun(){
      return this.$store.getters.getAllPubAlgoDataListGetters
    },
    setIntialsOfDataState(){
      if(this.algoDataList){
        this.algoDataListResults = this.algoDataList.results
      }
    },
    getMyDataListFun(){
      return this.$store.getters.getMyAlgoDataListGetters
    },
    setIntialsOfMyDataState(){
      if(this.myDataList){
        this.myDataListResults = this.myDataList.data
      }
    },
    getUserDetailsAgainFun() {
      return this.$store.getters.selfUserInfoGetters.data
    },
    SetIntialSuperUserStatus(){
      if (this.userDetails) {
        this.is_superuser = this.userDetails.is_superuser
        this.is_guestuser = this.userDetails.guest
      }
      return
    }
  }
}